import { render, staticRenderFns } from "./cmp-right-top-two.vue?vue&type=template&id=2c8a5c78"
import script from "./cmp-right-top-two.vue?vue&type=script&lang=js"
export * from "./cmp-right-top-two.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports